import "./styles.scss";
import _ from "lodash";
import { WorkspaceGroup } from "server";

export interface Location {
  name: string;
  description: string;
  endpoint?: string;
  available?: boolean;
  country?: string;
}
export interface WSGWithLocations extends WorkspaceGroup {
  locations: Location[];
}
interface CurrencyAmount {
  currency: string;
  amount: string;
}

interface SupportedStorage {
  count?: number;
  size: string;
  type: string;
  price_per_gb_hr?: CurrencyAmount;
  max_size?: string;
  min_size?: string;
  type_label?: string;
}
interface Prices {
  operating_system: string;
  instance_type: string;
  term_type: string;
  unit: string;
  price_usd: string;
  usage_type: string;
}
export interface GPUInstanceType {
  type: string;
  supported_gpus: [
    {
      count: number;
      memory: string;
      manufacturer: string;
      name: string;
      network_details?: string;
      memory_details?: string;
    }
  ];
  quota: {
    on_demand: {};
    spot: {};
    reserved: {
      id: string;
      name: string;
      maximum: number;
      current: number;
      unit: string;
    };
  };
  vcpu: number;
  memory: number | string;
  stoppable?: boolean;
  default_price: string;
  supported_storage: SupportedStorage[];
  network_performance: string;
  prices: Prices[];
  supported_architectures: string[];
  clock_speed_in_ghz: string;
  supported_num_cores: [];
  available_azs: [];
  default_cores: number;
  maximum_network_interfaces: number;
  workspace_groups: WSGWithLocations[];
  elastic_root_volume: boolean;
  location?: string;
  sub_location?: string;
  base_price?: CurrencyAmount;
  rebootable?: boolean;
  can_modify_firewall_rules?: boolean;
  sub_location_type_changeable?: boolean;
  is_available?: boolean;
  preemptible?: boolean;
  estimated_deploy_time?: string;
  provider?: string;
  cloud?: string;
}

export const GetProviderName = (
  instanceType: GPUInstanceType | undefined
): string | undefined => {
  if (!instanceType) {
    return undefined;
  }

  // By default, use the cloud from the instance type
  let cloud = instanceType.cloud;
  if (cloud != undefined && cloud != "") {
    return cloud.toUpperCase();
  }

  // If no cloud is set, use the provider from the instance type
  let provider = instanceType.provider;
  if (provider != undefined && provider != "") {
    return provider.toUpperCase();
  }

  // If no cloud or provider is set, return undefined
  return undefined;
};

export const GetCloudName = (
  instanceType: GPUInstanceType | undefined
): string | undefined => {
  if (!instanceType) {
    return undefined;
  }
  if (!!instanceType.cloud && !!instanceType.provider) {
    return `${instanceType.provider}`;
  }

  return undefined;
};
